module.exports = __webpack_public_path__ + "static/media/unisat.c9ecdf7b.png";